import {
  // Backdrop,
  // CircularProgress,
  // Grid,
  Stack,
} from "@mui/material";
// import { useEffect, useState } from "react";
import colors from "assets/theme/base/colors";
import MDTypography from "components/MDTypography";
import PriorityTable from "./components/priorityTable";
import MDButton from "components/MDButton";
import { useState } from "react";

function Priority() {
  let { primary } = colors;

  const [addOpen, setAddOpen] = useState(false);
  const [addSurveyId, setAddSurveyId] = useState("");
  const [addPriorityOrder, setAddPriorityOrder] = useState(1);
  const [addIsActive, setAddIsActive] = useState(true);
  const [addSubmitting, setAddSubmitting] = useState(false);
  const [addError, setAddError] = useState("");

  const openAdd = () => {
    setAddSurveyId("");
    setAddPriorityOrder(1);
    setAddIsActive(true);
    setAddError("");
    setAddSubmitting(false);
    setAddOpen(true);
  };

  return (
    <div>
      {/* <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        pb={1}
        sx={{ borderBottom: `2px solid ${primary.main}`, width: "100%" }}
        mb={2}
      >
        <MDTypography fontSize="22px" color="black" style={{ fontWeight: "600 !important" }} >
          Surveys Priority
        </MDTypography>
        <MDButton variant="contained" color="info" onClick={openAdd}>
          + New
        </MDButton>
      </Stack>

      <PriorityTable
        addOpen={addOpen}
        setAddOpen={setAddOpen}
        addSurveyId={addSurveyId}
        setAddSurveyId={setAddSurveyId}
        addPriorityOrder={addPriorityOrder}
        setAddPriorityOrder={setAddPriorityOrder}
        addIsActive={addIsActive}
        setAddIsActive={setAddIsActive}
        addSubmitting={addSubmitting}
        setAddSubmitting={setAddSubmitting}
        addError={addError}
        setAddError={setAddError}
      />
    </div>
  );
}

export default Priority;
